import {MO_SORT_OPTIONS} from '../../common/constants/MOs.js'
import Sort from '../../common/components/List/Sort.js'
import {setSort} from './moListActions.js'
import {moListQuerySelector} from './moListSelectors.js'
import {useSelector} from '../../store.js'

export default function MOSort() {
  const sort = useSelector(moListQuerySelector).sort

  return (
    <Sort
      items={MO_SORT_OPTIONS}
      value={sort}
      onChange={(value) => setSort(value)}
    />
  )
}
